import { useState } from 'react';

import { Button, Icon, Paper, Typography } from '@/ui';

import type { SharedArtifact } from '@/store/api/sharedArtifactApi';
import type { FC } from 'react';

import SessionSummaryView from '@/components/Sessions/SessionSummary/SessionSummaryView';

export type SharedSummaryStatus = 'loading' | 'ready' | 'empty' | 'error';

interface SharedSummaryDetailProps {
  artifact?: SharedArtifact | null;
  backLabel?: string;
  emptyMessage?: string;
  errorMessage?: string;
  onBack: () => void;
  status: SharedSummaryStatus;
}

const SharedSummaryDetail: FC<SharedSummaryDetailProps> = ({
  artifact = null,
  backLabel = 'Session',
  emptyMessage = 'No shared summary found for this session.',
  errorMessage = "We couldn't load this shared summary right now.",
  onBack,
  status,
}) => {
  const [isSummaryExpanded, setIsSummaryExpanded] = useState(true);
  const showSessionSummaryView = status === 'loading' || status === 'ready';

  return (
    <div className="min-h-screen overflow-x-hidden">
      <div className="container mx-auto flex max-w-screen-md flex-1 flex-col px-2 py-6 md:px-0">
        <div className="headline flex items-center py-5">
          <Button
            startIcon={<Icon>chevron_left</Icon>}
            variant="text"
            onClick={onBack}
          >
            <Typography className="title pl-1 ">{backLabel}</Typography>
          </Button>
        </div>

        <Paper
          className="mt-6 flex flex-col gap-4 px-8 pb-12 pt-8"
          variant="outlined"
        >
          {showSessionSummaryView && (
            <SessionSummaryView
              isExpanded={isSummaryExpanded}
              isLoading={status === 'loading'}
              markdown={artifact?.markdown || null}
              title={artifact?.title || undefined}
              onExpandedChange={setIsSummaryExpanded}
            />
          )}

          {status === 'error' && <Typography>{errorMessage}</Typography>}

          {status === 'empty' && <Typography>{emptyMessage}</Typography>}
        </Paper>
      </div>
    </div>
  );
};

export default SharedSummaryDetail;
